const isSupportPopover = 'popover' in HTMLElement.prototype

if (!isSupportPopover) {
	import('@oddbird/popover-polyfill/fn').then(({ apply }) => {
		apply()
	})
}

if (!('anchorName' in document.documentElement.style)) {
	// @ts-ignore
	import('https://unpkg.com/@oddbird/css-anchor-positioning')
}
